import useOnClickOutside from '@hooks/browser-events/use-on-click-outside';
import clsx from 'clsx';
import React, { useRef } from 'react';
import { useContextSelector } from 'use-context-selector';
import { SearchContext } from '@context/search.context';
import styles from '../filters.module.scss';
import SearchBarSuggestions, { ContentIds } from './search-bar-suggestions';

interface SearchModalProps {
  setIsSearchHeaderOpen: (value: React.SetStateAction<boolean>) => void;
  onSubmit: (text?: string) => Promise<void>;
}

const SearchModal: React.FC<SearchModalProps> = (props) => {
  const { setIsSearchHeaderOpen, onSubmit } = props;

  const searchQuery = useContextSelector(SearchContext, (v) => v.searchQuery);
  const brands = useContextSelector(SearchContext, (v) => v.brands);
  const suggestions = useContextSelector(SearchContext, (v) => v.suggestions);

  const container = useRef<HTMLDivElement>(null);

  useOnClickOutside(container, () => {
    setIsSearchHeaderOpen(false);
  });

  const results = [
    {
      queryResults: suggestions,
      contentId: ContentIds.ProductSuggestion,
      visible: searchQuery !== '',
    },
    {
      queryResults: brands,
      contentId: ContentIds.BrandSuggestion,
      visible: searchQuery !== '' && brands.length > 0,
    },
  ];

  return (
    <div
      ref={container}
      className={clsx(styles.searchModal)}
    >
      <div className={styles.innerWrapper}>
        {results.map((result) => (
          <React.Fragment key={result.contentId}>
            {result.visible && (
              <SearchBarSuggestions
                queryResults={result.queryResults}
                contentId={result.contentId}
                onSubmit={onSubmit}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SearchModal;
